/**
 * @description Плагин виджета онлайн-записи.
 * @constructor
 * @type {VuePlugin}
 */
export default function BookingWidget() {
  /**
   * @inheritDoc
   */
  this.install = (Vue) => {
    const bookMis32TopName = 'BookMis32Top';
    const loadScript = (scriptSrc) => {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    };
    Object.defineProperty(Vue.prototype, '$bookingWidget', {
      value: {
        initialized: () => {
          if (window[bookMis32TopName] && window[bookMis32TopName].initialized) {
            return window[bookMis32TopName].initialized();
          }
          return false;
        },
        open: (scriptSrc, config) => {
          window[bookMis32TopName] = window[bookMis32TopName] || [];
          const widget = window[bookMis32TopName];
          if (!(widget.initialized && widget.initialized())) {
            loadScript(scriptSrc);
          }
          widget.push(['init', config]);
          widget.push(['openModal']);
        },
        destroy: () => {
          (window[bookMis32TopName] || []).push(['destroy']);
        },
      },
    });
  };
}
